import * as yup from "yup";

export const validationSchema = yup.object().shape({
  vehicle_number: yup
    .string()
    .matches(
      /^[A-Z]{2}[0-9]{2}[A-Z]{1,2}[0-9]{4}$/,
      "Invalid vehicle number format (e.g., KA01AB1234)"
    ) // Matches common vehicle number format
    .required("Vehicle number is required"),
  
  licence_number: yup
      .string()
      .matches(
        /^[A-Z0-9\s]{10,20}$/,
        "Invalid licence number format (must be alphanumeric, allow spaces, 10-20 characters)"
      ) 
      .required("Licence number is required"),
});
